module.exports = __webpack_public_path__ + "media/application/images/icons/close-circle-blue-559334d6e9fde69487cf4105f5214788.svg";